// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';
import { hide, show } from 'utils/node';
import subscribe from 'utils/subscribe-back-in-stock';

export default component((node, ctx) => {
  const { emailButton, smsButton, form, formMessage } = choozy(node);

  const { formId, productId, variantId, keepVisible } = node.dataset;

  let selectedVariantId = variantId;

  const submit = async (type) => {
    const formData = new FormData(form);

    const contact = formData.get(type);
    const consent = formData.get('consent');

    try {
      await subscribe(
        contact,
        consent === 'on',
        selectedVariantId,
        type === 'email' ? 'EMAIL' : 'PHONE',
      );

      formMessage.classList.remove('error');
      formMessage.classList.add('success');
    } catch (err) {
      formMessage.classList.remove('success');
      formMessage.classList.add('error');
      // eslint-disable-next-line
      console.error(err);
    } finally {
      show(formMessage);
    }
  };

  emailButton.addEventListener('click', () => {
    submit('email');
  });

  smsButton?.addEventListener('click', () => {
    submit('phone');
  });

  const handleUpdate = (e) => {
    const { currentProductId } = e.detail;
    const { forms } = ctx.getState();
    const { selectedVariant } = forms[currentProductId];

    selectedVariantId = selectedVariant.id;

    if (keepVisible === 'true') return;

    if (!selectedVariant || selectedVariant.available) {
      hide(node);
    } else {
      show(node);
    }
  };

  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
    },
    { once: true },
  );
});
